export default "__VITE_ASSET__E$O5AHJE__"